export default __webpack_public_path__ + "9e7d79b.png";